.title {
  display: flex;
  flex-flow: column nowrap;
  gap: var(--mantine-spacing-xl);
  align-items: center;
  white-space: nowrap;
}

.title-text {
  position: relative;
  padding: var(--mantine-spacing-sm);
  font-size: min(10cqmin, 3.4rem);
  font-weight: 700;
  line-height: 1.2;
  text-align: center;
  &::before {
    position: absolute;
    top: 50%;
    left: -50%;
    width: 200%;
    height: 3rem;
    content: '';
    background: radial-gradient(ellipse at center, var(--mantine-color-dark-5) 0%, transparent 70%);
    mix-blend-mode: screen;
    translate: 0 -50%;
  }
}

.disclaimer {
  display: flex;
  gap: var(--mantine-spacing-xs);
  align-items: center;
  font-size: var(--mantine-font-size-xs);
  color: var(--mantine-color-dimmed);
  white-space: nowrap;
}
